<template>
  <main>
    <page-header-compact>
      Registro de Resultados laboratorio
    </page-header-compact>

    <div class="container-fluid">
      <!-- PATIENT & ORDER SUMMARY -->
      <div class="card border-left-lg border-left-primary mt-4">
        <div class="card-body p-3">
          <div class="row align-items-center">
            <div class="col-lg-7">
              <div class="d-flex align-items-center">
                <div class="bg-white rounded-circle d-flex align-items-center justify-content-center mr-3 border"
                  style="width: 50px; height: 50px;">
                  <i class="far fa-user text-primary fa-lg"></i>
                </div>
                <div v-if="Object.keys(usuario).length">
                  <div class="text-xs text-uppercase font-weight-600 text-primary mb-1">Datos del Paciente</div>
                  <h5 class="mb-0 font-weight-bold text-dark">
                    {{ usuario.nombre_1 }} {{ usuario.nombre_2 }} {{ usuario.apellido_1 }} {{ usuario.apellido_2 }}
                  </h5>
                  <div class="small text-gray-600 mt-1">
                    <span class="font-weight-bold border-right pr-2 mr-2">
                      {{ usuario.tipo_documento_rel ? usuario.tipo_documento_rel.abreviacion : '' }} {{
                        usuario.documento }}
                    </span>
                    <span>
                      <i class="far fa-calendar-alt mr-1"></i> {{ usuario.years }} Años ({{ usuario.fecha_nacimiento |
                        formatDate }})
                    </span>
                       
                  </div>
                  <div>
                    <span class="badge badge-light text-bold  px-2 ml-2 mt-2 font-weight-bold" v-if="ordentrabajo && ordentrabajo.sede">
                              <i class="fas fa-building mr-1"></i> {{ ordentrabajo.sede.NOMBRE_SEDE  }}
                            </span>
                  </div>
                </div>
                <div v-else class="text-muted small italic">
                  <i class="fas fa-info-circle mr-1"></i> Seleccione una orden para ver los datos del paciente
                </div>
              </div>
            </div>
            <div class="col-lg-5 pl-lg-4">
              <div class="row no-gutters">
                <div class="col-6 pr-2">
                  <label class="text-xs text-uppercase font-weight-bold text-muted mb-1">No. Orden de Trabajo</label>
                  <orden-trabajo-field :isSearch="true" ref="ordenTrabajoField" v-model="ordentrabajo"></orden-trabajo-field>
                </div>
                <div class="col-4 bg-light rounded-lg px-2 mx-4">
                  <label class="text-xs text-uppercase font-weight-bold text-gray-600 mb-1">No. Muestra</label>
                  <div class="h5 mb-0 font-weight-bold text-dark">{{ toma_muestra || '---' }}</div>
                </div>
                <div class="col-12 mt-2">
                  <label class="text-xs text-uppercase font-weight-bold text-muted mb-1">Fecha de Registro</label>
                  <input v-model="fecha" class="form-control form-control-sm bg-white" type="date"
                    style="border-radius: 5px;" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!areas.length" class="alert alert-warning border-left-lg shadow-sm mt-4">
        <div class="d-flex align-items-center">
          <i class="fas fa-exclamation-triangle mr-3 fa-lg"></i>
          <div>
            <h6 class="mb-0 font-weight-bold">Esperando información</h6>
            <p class="mb-0 small">Por favor, cargue una orden de trabajo válida para comenzar el registro de resultados.
            </p>
          </div>
        </div>
      </div>

      <!-- AREAS & EXAMS TABS -->
      <div class="card mt-2">
        <div class="card-header border-bottom">
          <div v-show="areas.length">
            <ul class="nav nav-tabs card-header-tabs" id="pills-tab" role="tablist">
              <li v-for="(area, i) in areas" :key="area.id" class="nav-item">
                <a :id="`nav_${area.id}`" :class="{ active: i === 0 }" :href="`#tab_${i}`"
                  class="nav-link text-uppercase font-weight-bold small px-3 mr-2" data-toggle="tab" role="tab">
                  {{ area.nombre }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="tab-content" id="nav-tabContent">
            <div v-for="(area, i) in areas" :id="`tab_${i}`" :key="`tab_${area.id}`" :class="{ 'show active': i === 0 }"
              class="tab-pane fade" role="tabpanel">
              <div class="card-header bg-gray-100">
                <div class="row align-items-center no-gutters text-uppercase font-weight-bold text-gray-600"
                  style="font-size: 0.7rem; letter-spacing: 0.05em;">
                  <div class="col-lg-3">Determinación</div>
                  <div class="col-lg-3 text-center">Resultado</div>
                  <div class="col-lg-3 px-3">Observaciones</div>
                  <div class="col-lg-3 text-right pr-3">Valores Referencia</div>
                </div>
              </div>

              <div class="list-group p-2">
                <div v-for="(entry, index) in area.items" :key="index">

                  <!-- CASE: GROUP -->
                  <template v-if="entry.type === 'group'">
                    <div class="bg-gray-200 px-3 py-2 border-bottom text-xs font-weight-bold text-dark small text-uppercase"
                      >
                      <i class="fas fa-list-ul text-primary mr-2"></i> {{ entry.nombre }}
                    </div>
                    <div v-for="examen in entry.items" :key="examen.id"
                      class="list-group-item px-3 py-1 border-bottom border-light">
                      <div class="row align-items-center no-gutters">
                        <div class="col-lg-3 pl-3 text-sm">
                          <span class="font-weight-bold text-gray-700">{{ examen.nombre }}</span>
                        </div>
                        <div class="col-lg-3">
                          <texto v-if="examen.tipo === 'texto'" v-model="examen.resultado"></texto>
                          <numerico v-if="examen.tipo === 'numero'" v-model="examen.resultado"></numerico>
                          <opciones v-if="examen.tipo === 'opcion'" v-model="examen.resultado"
                            :examen="examen.examen_rel"></opciones>
                        </div>
                        <div class="col-lg-3 px-3">
                          <textarea v-model="examen.observacion" class="form-control form-control-sm bg-light border-0"
                            rows="2" placeholder="Nota..." style="border-radius: 4px;"></textarea>
                        </div>
                        <div class="col-lg-3 text-right pr-3">
                          <div v-if="examen.valores_referencia != 0"
                            class="ref-value-box text-gray-600 font-weight-bold px-1 py-1" style="font-size: 0.75rem;">
                            {{ examen.valores_referencia }} <small class="ml-1">{{ examen.unidad }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- CASE: STANDALONE -->
                  <div v-else class="list-group-item px-3 py-1 border-bottom border-light">
                    <div class="row align-items-center no-gutters">
                      <div class="col-lg-3">
                        <span class="font-weight-bold text-dark text-sm">{{ entry.nombre }}</span>
                      </div>
                      <div class="col-lg-3">
                        <texto v-if="entry.tipo === 'texto'" v-model="entry.resultado"></texto>
                        <numerico v-if="entry.tipo === 'numero'" v-model="entry.resultado"></numerico>
                        <opciones v-if="entry.tipo === 'opcion'" v-model="entry.resultado" :examen="entry.examen_rel">
                        </opciones>
                      </div>
                      <div class="col-lg-3 px-3">
                        <textarea v-model="entry.observacion" class="form-control form-control-sm bg-light border-0"
                          rows="2" placeholder="Nota..." style="border-radius: 4px;"></textarea>
                      </div>
                      <div class="col-lg-3 text-left">
                        <div v-if="entry.valores_referencia != 0"
                          class="ref-value-box text-gray-600 font-weight-bold  py-1" style="font-size: 0.75rem;">
                          {{ entry.valores_referencia }} <small class="ml-1">{{ entry.unidad }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer bg-light border-top p-3">
                <div class="row align-items-center">
                  <div class="col-lg-6">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-user-md text-muted mr-2"></i>
                      <div class="flex-grow-1">
                        <label class="text-xs text-uppercase font-weight-bold text-muted mb-1 d-block">Profesional
                          Responsable</label>
                        <v-select-user v-model="area.id_profesional"></v-select-user>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <button class="btn btn-success btn-sm" @click="save()">
                <i class="fas fa-save fa-fw text-white-50"></i>
                Guardar Resultados
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import PageHeaderCompact from "../../../../components/layouts/content/page-header-compact";
import OrdenTrabajoField from "../../../../components/common/OrdenTrabajoField";
import texto from "./tipos/texto";
import numerico from "./tipos/numerico";
import opciones from "./tipos/opciones";
import Swal from "sweetalert2";
import resultadosLaboratorioService from "../../../../services/resultadosLaboratorioService";
//import asignacionAreasService from "../../../../services/asignacionAreasService";
import { isEmpty } from "lodash";
import VSelectUser from "@/components/common/vSelectUser.vue";

export default {
  components: {
    VSelectUser,
    PageHeaderCompact, OrdenTrabajoField, texto, numerico, opciones
  },
  data() {
    return {
      ordentrabajo: {},
      usuario: {},
      fecha: '',
      detalles: [],
      tieneRespuestas: false,
      areas: [],
      toma_muestra: '',
    }
  },
  watch: {
    ordentrabajo: {
      handler: async function () {
        this.areas = [];
        if (!isEmpty(this.ordentrabajo)) {

          this.usuario = this.ordentrabajo.usuario;
          this.toma_muestra = this.ordentrabajo.toma_muestra;

          const respuestas = await resultadosLaboratorioService.showByOrdenTrabajo(this.ordentrabajo.id);

          if (!isEmpty(respuestas.data)) this.tieneRespuestas = true;

          let examenes = [];

          const testWithSubtest = this.ordentrabajo.detalles.filter(x => x.examen.subexamen.length);
          const testWithoutSubtest = this.ordentrabajo.detalles.filter(x => x.examen.subexamen.length === 0);

          testWithSubtest.forEach(test => {
            examenes.push(...test.examen.subexamen.map(subtest => {

              let respuesta = '';
              let observacion = '';

              if (!isEmpty(respuestas.data)) {
                const tieneRespuesta = respuestas.data.detalles.find(x => parseInt(x.id_examen) === parseInt(subtest.id));
                if (tieneRespuesta !== undefined) {
                  respuesta = tieneRespuesta.resultado;
                  observacion = tieneRespuesta.observacion;
                }
              }

              return {
                id: subtest.id,
                nombre: subtest.nombre,
                observacion: observacion,
                tipo: subtest.tipo,
                opciones: subtest.opciones,
                resultado: respuesta,
                valores_referencia: subtest.valores_referencia,
                unidad: subtest.unidad,
                id_area_rel: test.examen.area,
                id_examen_padre: test.examen.id,
                nombre_padre: test.examen.nombre || test.examen.descripcion || 'Examen',
                examen_rel: subtest
              }
            }));
          });

          examenes.push(...testWithoutSubtest.map(test => {

            let respuesta = '';
            let observacion = '';

            if (!isEmpty(respuestas.data)) {
              const tieneRespuesta = respuestas.data.detalles.find(x => parseInt(x.id_examen) === parseInt(test.id_examen));
              if (tieneRespuesta !== undefined) {
                respuesta = tieneRespuesta.resultado;
                observacion = tieneRespuesta.observacion;
              }
            }
            return {
              id: test.examen.id,
              nombre: test.examen.nombre,
              tipo: test.examen.tipo,
              opciones: test.examen.opciones,
              id_area: test.examen.id_area,
              resultado: respuesta,
              observacion: observacion,
              valores_referencia: test.examen.valores_referencia,
              unidad: test.examen.unidad,
              id_area_rel: test.examen.area,
              id_examen_padre: test.examen.id_examen || test.examen.id,
              nombre_padre: (test.examen.examen_padre ? test.examen.examen_padre.nombre : null) ||
                (test.examen.padre ? test.examen.padre.nombre : null) ||
                (test.examen.examen ? test.examen.examen.nombre : null) ||
                test.examen.nombre,
              examen_rel: test.examen
            }
          }));

          /*const { data } = await asignacionAreasService.showByDate(this.ordentrabajo.fecha);

          const asignacion = data.length ? data.pop() : [];

          examenes = examenes.map(x => {
              const id_user = asignacion.detalles.find(y => y.id_area_lab === x.id_area)?.id_profesional || 0;
              return {
                  ...x,
                  id_profesional: nu
              }
          });*/

          let areasConExamenes = {};

          // Iterar sobre los detalles de la orden de trabajo
          examenes.forEach(detalle => {
            let area = detalle.id_area_rel;
            if (!area) return;

            if (!areasConExamenes[area.id]) {
              areasConExamenes[area.id] = {
                id: area.id,
                nombre: area.nombre,
                id_profesional: null,
                items: []
              };
            }

            if (detalle.id_examen_padre && detalle.id_examen_padre !== detalle.id) {
              // Group by parent
              let parentId = detalle.id_examen_padre;
              let group = areasConExamenes[area.id].items.find(x => x.type === 'group' && x.id === parentId);

              if (!group) {
                group = {
                  type: 'group',
                  id: parentId,
                  nombre: detalle.nombre_padre,
                  items: []
                };
                areasConExamenes[area.id].items.push(group);
              }
              group.items.push(detalle);
            } else if (detalle.examen_rel && detalle.examen_rel.subexamen && detalle.examen_rel.subexamen.length > 0) {
              // It's a parent with children (nested case)
              areasConExamenes[area.id].items.push({
                type: 'group',
                id: detalle.id,
                nombre: detalle.nombre_padre,
                items: detalle.items || [] // This shouldn't happen here as it's flattened, but just in case
              });
            } else {
              // Standalone
              areasConExamenes[area.id].items.push({
                type: 'item',
                ...detalle
              });
            }
          });

          this.areas = Object.values(areasConExamenes);
          this.fecha = this.tieneRespuestas ? respuestas.data.fecha : this.ordentrabajo.fecha;

          // asignar profesional a cada area segun los resultados
          if (!isEmpty(respuestas.data)) {
            this.areas.forEach(area => {
              // buscar resultados de examenes de esta area
              let examenesIds = [];
              area.items.forEach(entry => {
                if (entry.type === 'group') {
                  examenesIds.push(...entry.items.map(x => x.id));
                } else {
                  examenesIds.push(entry.id);
                }
              });

              const resultadosArea = respuestas.data.detalles.filter(x => examenesIds.includes(x.id_examen));
              // buscar profesional asignado a los resultados
              area.id_profesional = resultadosArea.length ? resultadosArea[0].id_profesional : null;
            });
          }
        } else {
          this.usuario = {};
          this.detalles = [];
        }
      },
      deep: true
    },
  },
  methods: {
    async save() {
      try {
        let resultados = [];

        // buscar areas que tienen resultados
        const areasConExamen = this.areas.filter(area => {
          return area.items.some(entry => {
            if (entry.type === 'group') {
              return entry.items.some(e => e.resultado !== '');
            }
            return entry.resultado !== '';
          });
        });

        // validar que todas las areas tengan un profesional asignado
        const areasSinProfesional = areasConExamen.filter(x => x.id_profesional === null);

        if (areasSinProfesional.length) {
          // concat all areas without professional
          const areasNames = areasSinProfesional.map(x => x.nombre).join(', ');
          await Swal.fire("Ups!", `Debe asignar un profesional a los resultados de area ` + areasNames, "error");
          return;
        }

        this.areas.forEach(x => {
          x.items.forEach(entry => {
            if (entry.type === 'group') {
              entry.items.forEach(e => {
                resultados.push({
                  nombre: e.nombre,
                  id_examen: e.id,
                  resultado: e.resultado,
                  id_profesional: x.id_profesional,
                  valores_referencia: e.valores_referencia,
                  observacion: e.observacion,
                });
              });
            } else {
              resultados.push({
                nombre: entry.nombre,
                id_examen: entry.id,
                resultado: entry.resultado,
                id_profesional: x.id_profesional,
                valores_referencia: entry.valores_referencia,
                observacion: entry.observacion,
              });
            }
          });
        });

        let resultados_laboratorios = {
          id_orden_trabajo: this.ordentrabajo.id,
          fecha: this.fecha,
          resultados: resultados
        }

        console.log(resultados_laboratorios);
        this.LoaderSpinnerShow();

        if (this.tieneRespuestas) {
          await resultadosLaboratorioService.update(resultados_laboratorios);
        } else {
          await resultadosLaboratorioService.store(resultados_laboratorios);
          this.tieneRespuestas = true;
        }

        this.LoaderSpinnerHide();

        Swal.fire("Datos Guardados con exito", "", "success");
        this.limpiarCampos();


      } catch (error) {
        console.log(error);
        this.LoaderSpinnerHide();
        Swal.fire("Upss", "Ocurrio un error al procesar la solicitud", "error");
      }
    },
    limpiarCampos() {
      this.ordentrabajo = {};
      this.usuario = {};
      this.areas = [];
      this.tieneRespuestas = false;
      this.fecha = '';
    }
  },
  created() {
    // get work order id from url
    const workOrderId = this.$route.params?.workOrderId;
    if (workOrderId) {
      // next tick to ensure the component is mounted
      this.$nextTick(() => {
        this.$refs.ordenTrabajoField.setIdOrden(workOrderId);
      });
      // get date from query params if present
      const date = this.$route.query?.orderDate;
      if (date) {
        this.fecha = date
      }
    }
  }

}
</script>

<style scoped>
.ref-value-box {
  background-color: #f1f5f9;
  border-radius: 4px;
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  word-wrap: break-word;
  text-align: right;
  line-height: 1.2;
}

.text-gray-600 {
  color: #475569 !important;
}

.font-weight-600 {
  font-weight: 600;
}

.bg-gray-100 {
  background-color: #f1f5f9 !important;
}
</style>
